/**
 * crmFetch.js
 *
 * Thin wrapper around `fetch` that injects the CRM HTTP Basic auth header
 * stored in `localStorage.crmAuth` (set by the /crm login form).
 *
 * Falls back to the default admin credentials so existing flows that rely on
 * the dev environment's hardcoded admin keep working when there is no logged-in
 * user (e.g. server-rendered preview links, internal dashboards).
 *
 * Usage:
 *   import { crmFetch } from '../utils/crmFetch';
 *   const r = await crmFetch(`${API}/api/crm/invoicing/programs`);
 */
export const crmFetch = (url, options = {}) => {
  const auth = (typeof window !== 'undefined' && localStorage.getItem('crmAuth'))
    || (typeof window !== 'undefined' && window.btoa ? window.btoa('admin:kioo2025!') : '');
  const headers = {
    ...(options.headers || {}),
    Authorization: `Basic ${auth}`,
  };
  return fetch(url, { ...options, headers });
};

export default crmFetch;
